import { Common } from './common';
import { DisplayableWorkflow } from './models/workflow';
import { Order, ProposedOrder, Status, StructuredOrder } from './models/order';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllByEncounterId(encounterId: string): Promise<StructuredOrder[]> {
    const url = this.common.constructPath(`/orders/${encounterId}`);
    return this.common.getJSON(url);
  }

  async updateStatusByOrderId(
    orderId: string,
    status: Status,
  ): Promise<{
    order: StructuredOrder;
    workflow?: DisplayableWorkflow;
  }> {
    const url = this.common.constructPath(`/orders/${orderId}/status`);
    return this.common.postJSON(url, { status }, 'PATCH');
  }

  async structureOrder(
    encounterId: string,
    text: string,
  ): Promise<ProposedOrder[]> {
    const url = this.common.constructPath(`/orders/structure`);
    const { body } = await this.common.postJSON(
      url,
      { encounterId, text },
      'POST',
    );
    return body;
  }

  async approveOnDevice(orderId: string): Promise<Order> {
    const url = this.common.constructPath(
      `/orders/${orderId}/approvedOnDevice`,
    );
    return this.common.postJSON(url, {}, 'POST');
  }
}
